import { PluginListenerHandle, registerPlugin } from '@capacitor/core'

interface APIPluginInterface {
	addListener(eventName: string, listenerFunc: (data: any) => void): Promise<PluginListenerHandle>
}

const APIPlugin = registerPlugin<APIPluginInterface>('APIPlugin')

export default APIPlugin